module.exports = __webpack_public_path__ + "img/制御工学3_9.bec55071.png";